import { useQuery } from '@apollo/client';
import { QUOTE_HIGHLIGHT_QUERY } from '../graphQL/quoteHighlightQuery';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import QuoteHighlightDetails from './QuoteHighlightDetails';
import { parseQuoteHighlightQueryResult } from '../graphQL/quoteHighlightQueryParser';
import QuoteHighlightActions from './QuoteHighlightActions';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuoteHighlight = props => {
  const {
    objectId,
    permissions,
    closeSidebar
  } = props;
  const {
    data,
    loading,
    error
  } = useQuery(QUOTE_HIGHLIGHT_QUERY, {
    variables: {
      quoteId: objectId
    },
    fetchPolicy: 'network-only'
  });
  if (loading) {
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      paddingInline: "600",
      paddingBlockStart: "600",
      paddingBlockEnd: "0",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-primary-default",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 128
      })
    });
  }
  if (error || !data || !data.crmObject) {
    throw new Error('Error fetching quote highlight data');
  }
  const {
    quote,
    quoteEsign,
    userEmail,
    userOwnerId,
    allowPayBeforeEsign
  } = parseQuoteHighlightQueryResult(data);
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "600",
    paddingBlockStart: "600",
    paddingBlockEnd: "0",
    as: "div",
    children: [/*#__PURE__*/_jsx(QuoteHighlightActions, {
      quote: quote,
      quoteEsign: quoteEsign,
      userEmail: userEmail,
      canCurrentUserEditQuote: permissions.canEditSubject,
      userOwnerId: userOwnerId,
      scopes: permissions.scopes,
      gates: permissions.gates,
      closeSidebar: closeSidebar
    }), /*#__PURE__*/_jsx(QuoteHighlightDetails, {
      quote: quote,
      allowPayBeforeEsign: allowPayBeforeEsign
    })]
  });
};
export default QuoteHighlight;